import React from 'react';
import '../../assets/css/style.css';
import RadioChipContainer from './elements/RadioChipContainer';

const ProfileGender = () => {
    const genderNames = ['Male','Female','Other'];

    return (
        <div className="uni-form">  
            <RadioChipContainer labels={genderNames} type="gender" />
        </div>
    );
}

export default ProfileGender;